/** Urutan rombel SD: B → A → C (6B, 6A, 5B, 5A, … 3C, 3B, 3A). */
const ROMBEL_ORDER = { B: 0, A: 1, C: 2 };

export function rombelSortRank(classroom) {
  return ROMBEL_ORDER[String(classroom || '').trim().toUpperCase()] ?? 99;
}

/** Urut kelas tinggi dulu, rombel B→A→C, lalu nama. */
export function compareStudentsByGradeClassroom(a, b) {
  const ga = Number(a?.grade) || 0;
  const gb = Number(b?.grade) || 0;
  if (ga !== gb) return gb - ga;

  const rombelDiff = rombelSortRank(a?.classroom) - rombelSortRank(b?.classroom);
  if (rombelDiff !== 0) return rombelDiff;

  return String(a?.full_name || '').localeCompare(String(b?.full_name || ''), 'id');
}

export function sortStudentsByGradeClassroom(list) {
  return [...list].sort(compareStudentsByGradeClassroom);
}
